<template>
  <div
    class="avatar"
    :style="divClass"
  >
    <img
      :src="img"
    >
  </div>
</template>


<script>

export default {
    name: "TheAvatar",

    props: ['img', 'maxWidth'],

    data() {
        return {
            divClass: {
                maxWidth: this.maxWidth
            }
        }
    }
}

</script>

<style lang="scss" scoped>

.avatar {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    
    img {
        max-width: 100%;
        border-radius: 50%;
    }
}

</style>